import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Container from '../components/misc/Container.js';
import TabAccount from '../components/Profile/TabAccount.js';
import TabOrder from '../components/Profile/TabOrder.js';
import LayoutHomepage from '../layout/LayoutHomepage.js';
const Profile = () => {
  const [showTab, SetShowTab] = useState(1);
  return (
    <LayoutHomepage>
      <div className="flex w-full mt-32 min-h-3/4">
        <Container>
          <div className="bg-white rounded-md w-full my-8 py-8 pr-6 flex min-h-3/4">
            <div className="flex flex-col w-3/12 border-r border-gray-200 max-w-xs">
              <div
                className={
                  'flex py-3 hover:bg-orange-100 menu-sidebar my-2 cursor-pointer ' +
                  (showTab === 1
                    ? '  text-basic-orange bg-orange-100 icon-active'
                    : ' bg-white text-font-gray')
                }
                onClick={() => SetShowTab(1)}
              >
                <span className="flex items-center  mx-auto w-8/12 ">
                  <svg
                    id="Layer_x0020_1"
                    xmlns="http://www.w3.org/2000/svg"
                    width="25.044"
                    height="25.044"
                    viewBox="0 0 25.044 25.044"
                  >
                    <g id="_105553161644384" transform="translate(0)">
                      <path
                        id="Path_1581"
                        data-name="Path 1581"
                        d="M17.792,6.255a6.261,6.261,0,1,0-6.255,6.267A6.256,6.256,0,0,0,17.792,6.255Zm-1.97,0a4.361,4.361,0,0,0-4.285-4.427A4.353,4.353,0,0,0,7.252,6.255a4.356,4.356,0,0,0,4.285,4.439A4.364,4.364,0,0,0,15.822,6.255Z"
                        transform="translate(0.985)"
                        fill="#f86542"
                        fillRule="evenodd"
                      />
                      <path
                        id="Path_1582"
                        data-name="Path 1582"
                        d="M22.136,14.612a21.538,21.538,0,0,0-9.614-2.552,21.538,21.538,0,0,0-9.614,2.552A5.384,5.384,0,0,0,0,19.4v.819A2.568,2.568,0,0,0,2.552,22.79H22.481a2.571,2.571,0,0,0,2.564-2.576V19.4a5.384,5.384,0,0,0-2.908-4.783Zm.926,5.614a.771.771,0,0,1-.748.8H2.73a.781.781,0,0,1-.76-.8v-.819a3.64,3.64,0,0,1,1.911-3.217,19.072,19.072,0,0,1,8.641-2.362,19.072,19.072,0,0,1,8.641,2.362,3.629,3.629,0,0,1,1.9,3.217v.819Z"
                        transform="translate(0 2.254)"
                        fill="#f86542"
                        fillRule="evenodd"
                      />
                    </g>
                  </svg>
                  <p className="ml-4">Akun</p>
                </span>
              </div>

              <div
                className={
                  'flex py-3 hover:bg-orange-100 menu-sidebar my-2 cursor-pointer ' +
                  (showTab === 2
                    ? '  text-basic-orange bg-orange-100 icon-active'
                    : ' bg-white text-font-gray')
                }
                onClick={() => SetShowTab(2)}
              >
                <span className="flex items-center  mx-auto w-8/12 ">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="21.809"
                    height="20.298"
                    viewBox="0 0 21.809 20.298"
                  >
                    <g
                      id="Group_4256"
                      data-name="Group 4256"
                      transform="translate(-136 -602.702)"
                    >
                      <path
                        id="Union_1"
                        data-name="Union 1"
                        d="M.906,8.214a.906.906,0,0,1,0-1.813H19.562L14.708,1.547A.906.906,0,1,1,15.989.266l5.554,5.554a.907.907,0,0,1,.129,1.12.907.907,0,0,1-.828,1.275Z"
                        transform="translate(136 602.702)"
                        fill="#f86542"
                      />
                      <path
                        id="Union_2"
                        data-name="Union 2"
                        d="M.906,8.214a.906.906,0,0,1,0-1.813H19.562L14.708,1.547A.906.906,0,1,1,15.989.266l5.554,5.554a.907.907,0,0,1,.129,1.12.907.907,0,0,1-.828,1.275Z"
                        transform="translate(157.809 623) rotate(180)"
                        fill="#f86542"
                      />
                    </g>
                  </svg>

                  <p className="ml-4">Pesanan</p>
                </span>
              </div>

              <Link
                to="/welcome"
                className={
                  'flex py-3 hover:bg-orange-100 menu-sidebar my-2 cursor-pointer ' +
                  (showTab === 3
                    ? '  text-basic-orange bg-orange-100 icon-active'
                    : ' bg-white text-font-gray')
                }
              >
                <span className="flex items-center  mx-auto w-8/12 ">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22.401"
                    height="22.401"
                    viewBox="0 0 22.401 22.401"
                  >
                    <path
                      id="Icon_ionic-md-exit"
                      data-name="Icon ionic-md-exit"
                      d="M17.7,19.761l-1.7,1.7L9.95,15.4l6.056-6.056,1.7,1.7-3.149,3.149H26.3v2.422H14.613ZM6.922,4.5H23.879A2.429,2.429,0,0,1,26.3,6.922v4.845H23.879V6.922H6.922V23.879H23.879V19.034H26.3v4.845A2.429,2.429,0,0,1,23.879,26.3H6.922A2.429,2.429,0,0,1,4.5,23.879V6.922A2.429,2.429,0,0,1,6.922,4.5Z"
                      transform="translate(-4.2 -4.2)"
                      fill="#f86542"
                      stroke="#fff"
                      strokeWidth="0.6"
                    />
                  </svg>

                  <p className="ml-4">Keluar</p>
                </span>
              </Link>
            </div>
            <div className="flex flex-col w-9/12 px-12">
              {showTab === 1 ? <TabAccount /> : <TabOrder />}
            </div>
          </div>
        </Container>
      </div>
    </LayoutHomepage>
  );
};

export default Profile;
